<template>
    <svg width="35" height="70" viewBox="0 0 35 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.500003 68.75L34.25 35L0.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>